import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { useEnpsFormContext } from 'modules/enps/lib/EnpsFormContext'
import type EnpsForm from 'modules/enps/store/models/Form'

interface Props {
  form: EnpsForm
}

function StopedBlankState({ form: enpsForm }: Props) {
  const { setRefreshForm } = useEnpsFormContext()
  const resumeSurvey = i18n.t('enps.answer.button_resume_survey')
  const { start_on } = enpsForm.attributes
  const today = moment().startOf('day')
  const diffDays = moment(start_on).diff(today, 'days')

  const submit = async () => {
    let errorMessage = ''
    if (!enpsForm.isFinished) {
      return
    }

    const { success, value } = await asyncAction(() => {
      return enpsForm.rpc('start_form', {
        start_on: diffDays >= 0 ? start_on : today.format('YYYY-MM-DD'),
        schedule: enpsForm.periodicity,
        end_on: null,
      })
    })

    if (success) {
      enpsForm.set(value)
      setRefreshForm(true)
      errorMessage = value
    }

    track(trackingEvents.enps.resumeSurveyEnps, {
      frequency: enpsForm.periodicity,
      error_message: errorMessage,
    })
  }

  return (
    <Box paddingTop="s120" paddingBottom="s120" gap="s16" alignItems="center">
      <Icon.Large icon="love-hands" />
      <Text.Header2>{i18n.t('enps.answer.title_resume_survey')}</Text.Header2>
      <Text.Normal>{i18n.t('enps.answer.description_resume_survey')}</Text.Normal>
      <Box alignItems="center">
        <Button type="primary" onClick={submit}>
          {resumeSurvey}
        </Button>
      </Box>
    </Box>
  )
}
export default observer(StopedBlankState)
